/**
 * Page Compositions for Pillar Properties Theme
 * 
 * Extends the base avenue theme pages with Pillar Properties customizations.
 */

import { pages as basePages } from '@vibesites/theme-avenue/pages';
import type { PageComposition } from '@vibesites/runtime';

/**
 * Pillar Properties page overrides.
 * Can customize section order, add/remove sections, or change props.
 */
const pageOverrides: Partial<Record<string, PageComposition>> = {
  // Add page overrides here
};

/**
 * Final merged pages for Pillar Properties properties.
 */
export const pages: Record<string, PageComposition> = {
  ...basePages,
  ...pageOverrides,
};

export default pages;
